import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'AI in Testing - Bias and Quality',
                topics: [
                    'Testing AI systems: strategies and best practices',
                    'Bias in AI-powered testing: how to detect and mitigate it',
                    'Predicting software quality with machine learning: a case study',
                    'AI-based fault localization: approaches and evaluation',
                    'Leveraging AI for continuous integration and delivery',
                ],
            },
            {
                title: 'AI in Test Automation',
                topics: [
                    'Reinforcement learning for test automation: opportunities and challenges',
                    'AI-driven testing of chatbots and virtual assistants',
                    'The role of AI in exploratory testing',
                ],
            },
            {
                title: 'Future of Software Testing with AI',
                topics: [
                    'The impact of AI on traditional testing roles and responsibilities',
                    'The future of software testing: a perspective from AI experts',
                    'How AI is changing the landscape of software testing tools',
                    'AI-assisted risk-based testing: benefits and limitations',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What is the event about?</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;